<template>
  <img :src="src" :alt="alt" :class="classes" loading="lazy" />
</template>

<script setup lang="ts">
import { computed } from 'vue'

/** UiImg — Vuetify <v-img> replacement using a native <img>. */
const props = withDefaults(
  defineProps<{
    src?: string
    alt?: string
    contain?: boolean
  }>(),
  { src: undefined, alt: '', contain: false },
)

const classes = computed(() =>
  ['block max-w-full', props.contain ? 'object-contain' : 'object-cover'].join(
    ' ',
  ),
)
</script>
